module.exports = __webpack_public_path__ + "static/media/carl987-106.111c3ca9.jpg";